/**
 * 个人信息模块路由
 */

export default [
  // 个人信息
  {
    path: 'admin/profile',
    name: 'Profile',
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/views/setting/profile/ProfileView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'profile',
      title: '个人信息',
      hidden: true
    }
  }
]
